import { commonIcons } from '../common/icon';
import { IIcon } from '../types/icon';

export const icon: IIcon = {
  ...commonIcons,
  logo: 'timHortonsLogo',
  loyaltyCard: 'loyaltyCard',
  mapleLeaf: 'mapleLeaf',
  mapleLeafFilled: 'mapleLeafFilled',
  mobileNavHome: 'mobileNavHomeTH',
  order: 'coffeeCup',
  rewards: 'thRewards',
  sandwiches: 'noop',
  sauces: 'noop',
  scanRewards: 'scanRewards',
  storeMarker: 'storeMarker',
  timsCard: 'timsCard',
  timsLogo: 'timsLogo',
  timsText: 'timsText',
};
